/**
 * Page /admin/clients — Clients du site (particuliers et entreprises).
 * Wrapper sur AdminUsers en mode "clients".
 */
import AdminUsers from "@/pages/AdminUsers";

export default function AdminClients() {
    return <AdminUsers mode="clients" />;
}
